<div class="modal-header fw-semibold text-gray-800">
  Alert!
  <div class="btn btn-sm btn-icon btn-active-color-primary" (click)="activeModal.close('Close click')">
    <span class="svg-icon svg-icon-1" [inlineSVG]="'./assets/media/icons/duotune/arrows/arr061.svg'"></span>
  </div>
</div>
<div class="modal-body">
  <div class="container-fluid">
    <div class="justify-content-center fw-semibold text-gray-800"
      *ngIf="type == 'installed' && currentUser?.mainRole != 'Mentor'">
      {{appData?.name}} subscription required.
      <hr>
      <h5 class="text-danger" *ngIf="trailInfo">
        {{trailInfo}}
      </h5>
    </div>

    <div class="justify-content-center fw-semibold text-gray-800"
      *ngIf="type == 'installed' && currentUser?.mainRole == 'Mentor'">
      {{appData?.name}} subscription required.
      <hr>
      <p>As a mentor, you are not able to subscribe to the app directly. Please contact your administration to arrange a
        subscription.</p>
      <h5 class="text-danger" *ngIf="trailInfo">
        {{trailInfo}}
      </h5>
    </div>


    <div class="justify-content-center fw-semibold text-gray-800" *ngIf="type == 'notInstalled'">
      Unistalled {{appData?.name}}, please install from Uninstalled Apps tab.
      <!-- <span *ngIF="appCode=='A09.OM'">Organization Management</span>
      <span *ngIF="appCode=='A06.CRM'">CRM</span>
      <span *ngIF="appCode=='A10.AC'">Accountant</span>
      <span *ngIF="appCode=='A05.BD'">Directory</span>
      <span *ngIF="appCode=='A04.ER'">Email Read</span>
       <span *ngIF="appCode=='A11.JS'">Jobs</span>
       <span *ngIF="appCode=='A15.EC'">Campaigns</span>
       <span *ngIF="appCode=='A12.BA'">Be as advisor</span>
       <span *ngIF="appCode=='A07.DM'">Drive</span>
       <span *ngIF="appCode=='A02.DF'">Dynamic forms</span>
       <span *ngIF="appCode=='A23.AU'">Audits</span>
       <span *ngIF="appCode=='A13.LM'">Licensure</span>
       <span *ngIF="appCode=='A27.FU'">Fix Uncat</span> -->
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-danger me-auto" (click)="activeModal.close('Close click')">Close</button>
  <p class="text-primary" *ngIf=" currentUser?.mainRole == 'User' || currentUser?.mainRole == 'HTM_User'">Please contact
    your admin to subscribe.</p>
  <button type="button"
    *ngIf="(type == 'installed' && currentUser?.mainRole != 'User' && currentUser?.mainRole != 'HTM_User') || (type == 'installed' && currentUser?.mainRole != 'Mentor') "
    class="btn btn-sm btn-primary float-right" (click)="buyApp()">Subscribe</button>
  <button type="button"
    *ngIf="type == 'notInstalled' && currentUser?.mainRole != 'User' && currentUser?.mainRole != 'HTM_User'"
    class="btn btn-sm btn-primary float-right" (click)="goTpApps()">Go to Apps</button>

</div>